import { render } from "./list-component.vue?vue&type=template&id=23d4159c&scoped=true&lang=html"
import script from "./list-component.vue?vue&type=script&lang=js"
export * from "./list-component.vue?vue&type=script&lang=js"

import "./list-component.vue?vue&type=style&index=0&id=23d4159c&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d4159c"]])

export default __exports__